export enum ChapterStatusEnum {
  RESTRICTED = 'RESTRICTED',
  PUBLISHED = 'PUBLISHED',
  UNPUBLISHED = 'UNPUBLISHED',
}
